// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "client" + "-" + "dc4943c6827b38cba52a" + ".css";
};